import baseApi from "@/lib/redux/api/baseApi";

export const globalSettingsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get All Settings
    getSettings: builder.query({
      query: () => ({
        url: "/settings",
        method: "GET",
      }),
      providesTags: ['Settings'],
    }),

    // Get Specific Setting
    getSetting: builder.query({
      query: (key) => ({
        url: `/settings/${key}`,
        method: "GET",
      }),
      providesTags: ['Settings'],
    }),

    // Create/Update Single Setting
    updateSettings: builder.mutation({
      query: (settingsData) => ({
        url: "/settings",
        method: "POST",
        body: settingsData,
      }),
      invalidatesTags: ['Settings'],
    }),

    // Get logo info (path + url)
    getLogo: builder.query({
      query: (userId) => ({
        url: "/profile/logo/info",
        method: "GET",
        params: userId ? { user_id: userId } : undefined,
      }),
      providesTags: ['Settings'],
    }),
    

    // Upload or change logo
    uploadLogo: builder.mutation({
      query: ({ file, userId }) => {
        const formData = new FormData();
        formData.append("logo", file);
        if (userId) {
          formData.append("user_id", userId);
        }

        return {
          url: "/profile/logo/add",
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: ['Settings'],
    }),

    // Delete logo
    deleteLogo: builder.mutation({
      query: (userId) => ({
        url: "/profile/logo/delete",
        method: "DELETE",
        body: userId ? { user_id: userId } : undefined,
      }),
      invalidatesTags: ['Settings'],
    }),

    // Update Multiple Settings
    updateMultipleSettings: builder.mutation({
      query: (settingsData) => ({
        url: "/settings/multiple",
        method: "POST",
        body: settingsData,
      }),
      invalidatesTags: ['Settings'],
    }),
  }),
  overrideExisting: true,
});

// Export hooks
export const {
  useGetSettingsQuery,
  useGetSettingQuery,
  useUpdateSettingsMutation,
  useUpdateMultipleSettingsMutation,
  useGetLogoQuery,
  useUploadLogoMutation,
  useDeleteLogoMutation,
} = globalSettingsApi;
